import axios from 'axios';
import { createContext, useContext, useEffect, useState } from 'react';

const AnioLectivoContext = createContext();
const STORAGE_KEY = 'selectedAnioLectivoId';

export const useAnioLectivo = () => {
    const context = useContext(AnioLectivoContext);
    if (!context) {
        throw new Error('useAnioLectivo must be used within AnioLectivoProvider');
    }
    return context;
};

export const AnioLectivoProvider = ({ children }) => {
    const [aniosLectivos, setAniosLectivos] = useState([]);
    const [selectedAnio, setSelectedAnio] = useState(null);
    const [loading, setLoading] = useState(true);

    useEffect(() => {
        fetchAniosLectivos();
    }, []);

    const fetchAniosLectivos = async () => {
        try {
            const response = await axios.get('/api/anios-lectivos');
            const data = response.data;
            setAniosLectivos(data);

            // Try to restore from localStorage first
            const savedAnioId = localStorage.getItem(STORAGE_KEY);
            let yearToSelect = null;

            if (savedAnioId) {
                // Try to find the saved year
                yearToSelect = data.find(anio => anio.id === parseInt(savedAnioId));
            }

            // If no saved year or saved year not found, use active year
            if (!yearToSelect) {
                yearToSelect = data.find(anio => anio.activo);
            }

            // If still no year, use first available
            if (!yearToSelect && data.length > 0) {
                yearToSelect = data[0];
            }

            if (yearToSelect) {
                setSelectedAnio(yearToSelect);
                localStorage.setItem(STORAGE_KEY, yearToSelect.id.toString());
            }
        } catch (error) {
            console.error('Error fetching años lectivos:', error);
        } finally {
            setLoading(false);
        }
    };

    const changeAnio = (anio) => {
        setSelectedAnio(anio);
        // Save to localStorage
        if (anio) {
            localStorage.setItem(STORAGE_KEY, anio.id.toString());
        }
    };

    const value = {
        aniosLectivos,
        selectedAnio,
        changeAnio,
        loading
    };

    return (
        <AnioLectivoContext.Provider value={value}>
            {children}
        </AnioLectivoContext.Provider>
    );
};
